import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const tmdb = defineConnector({
  identifier: "tmdb",
  name: "TMDB",
  tagLine: "Movie ratings and information",
  keywords:
    "the movie database movies films cinema ratings votes television tv",
  aiContext:
    "Use TMDB API v3 to search for movies and retrieve movie details. Ratings are TMDB community vote_average and vote_count values, not IMDb ratings. User-authorized account actions are not configured by this connector.",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://api\\.themoviedb\\.org/3/.*",
  auth: (app) => bearerAuth(app.secret.readAccessToken),
  steps: [
    {
      title: "Get your TMDB API Read Access Token",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to your TMDB account and open [API settings](https://www.themoviedb.org/settings/api). Request API access if you haven’t already, then copy the **API Read Access Token**. Use this token, not the API key or a temporary request token.",
        },
        {
          kind: "markdown",
          content:
            "Review [TMDB’s API terms](https://www.themoviedb.org/api-terms-of-use) for permitted use and attribution requirements. This connector uses TMDB and the TMDB APIs but is not endorsed, certified, or otherwise approved by TMDB.",
        },
      ],
    },
    {
      title: "Enter your API Read Access Token",
      items: [
        {
          kind: "input",
          label: "API Read Access Token",
          required: true,
          target: { kind: "secrets", field: "readAccessToken" },
          helperText: "Paste the token only, without the Bearer prefix.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.themoviedb.org/3/configuration",
      method: "GET",
      headers: { Accept: "application/json" },
      expectedStatus: 200,
      expectedBodyContains: ['"images"', '"change_keys"'],
    }),
  },
});
